import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header-modal-footer',
  templateUrl: './header-modal-footer.component.html',
  styleUrls: ['./header-modal-footer.component.css']
})
export class HeaderModalFooterComponent {
  @Input() submitText: string = 'Submit';
  @Input() cancelText: string = 'Cancel';
  @Input() submitColor: string = '#000090';
  @Input() submitDisabled: boolean = false;
  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
